module.exports = __webpack_public_path__ + "img/target-2.93ff4e1b.jpg";